import { render } from "./MiniApp.vue?vue&type=template&id=53b1a2e4&scoped=true"
import script from "./MiniApp.vue?vue&type=script&lang=js"
export * from "./MiniApp.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./MiniApp.vue?vue&type=style&index=1&id=53b1a2e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b1a2e4"]])

export default __exports__